import React, {useEffect, useState} from 'react';
import {Box, CardContent, Grid, Typography} from '@deere/fuel-react';
import AccordionDetails from "@material-ui/core/AccordionDetails";
import {useStyles} from "../shared/styles/Ratings";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {LAST_UPLOADED_DATE} from "../shared/Constants";
import {RatingObjectiveQPPMDetails} from "./RatingObjectiveQPPMDetails";
import {RatingNotApplicable} from "./RatingNotApplicable";
import {RatingNotApplicableView} from "./RatingNotApplicableView";
import {toCapitalizeSplitStr} from "../shared/utils";
import ReactChart from './ReactChart';

const AeRatingChart = ({chartData, score}) => {
    return (<ReactChart
        axes={chartData?.['axisPoints']}
        datapoint={(() => {
            const points = chartData?.['axisPoints'];

            for (let i = 0; i < points.length - 1; i++) {
                if (score > points[i].x && score <= points[i + 1].x) {
                    return {
                        x: points[i + 1].x,
                        y: points[i + 1].y,
                        label: score
                    }
                }
            }

            // Out of bounds handling
            if (score <= points[0].x) {
                return {
                    x: points[0].x,
                    y: points[0].y,
                    label: score
                }
            }
            if (score >= points[points.length - 1].x) {
                return {
                    x: points[points.length - 1].x,
                    y: points[points.length - 1].y,
                    label: score
                }
            }
            return {
                x: 0,
                y: 0,
                label: 0
            }
        })()}
        title={chartData?.['chartTitle']}
        xLabel={chartData?.['xaxisLabel']}
        yLabel={chartData?.['yaxisLabel']}
    />)
}

export const RatingObjectiveDetails = ({
                                           criteria,
                                           suppliers,
                                           functionalAreaId,
                                           isNotApplicableOpen,
                                           isEditNotApplicableOpen,
                                           onNotApplicableActions,
                                           isParentOpen,
                                           chartData
                                       }) => {
    const classes = useStyles();
    const path = process.env.REACT_APP_ALL_SUPPLIERS_DISPLAY_CHARTS;
    const [expandedPanels, setExpandedPanels] = useState({});

    // Close all child accordions when parent closes
    useEffect(() => {
        if (isParentOpen === false) {
            setExpandedPanels({});
        }
    }, [isParentOpen]);

    const handleNotApplicableAction = (data, type) => {
        onNotApplicableActions(data, type)
    }

    const handleAccordionChange = (panel) => (event, isExpanded) => {
        setExpandedPanels(prev => ({
            ...prev,
            [panel]: isExpanded
        }));
    };


    return <AccordionDetails className={classes.accordionDetails}>
        <Grid container alignItems="center">
            <Grid item xs={12}>
                {isNotApplicableOpen &&
                    <Grid item xs={12}>
                        <Box style={{padding: "0 2.25rem 1rem 3rem"}} display="flex" alignContent="center">
                            <RatingNotApplicable
                                criteriaId={criteria.id}
                                suppliers={suppliers}
                                onNotApplicableAction={handleNotApplicableAction}
                                criteria={criteria}
                            />
                        </Box>
                    </Grid>
                }
                {isEditNotApplicableOpen &&
                    <Grid item xs={12}>
                        <Box style={{padding: "0 2.25rem 1rem 3rem"}} display="flex" alignContent="center">
                            <RatingNotApplicable
                                criteriaId={criteria.id}
                                suppliers={suppliers}
                                onNotApplicableAction={handleNotApplicableAction}
                                criteria={criteria}
                                isEdit={true}
                            />
                        </Box>
                    </Grid>
                }
                {criteria.notApplicableReason && !isNotApplicableOpen && !isEditNotApplicableOpen && (
                    <RatingNotApplicableView criteria={criteria}/>
                )}
                {suppliers.length < 2 && chartData?.[suppliers[0].supplierNumber] &&
                    <Box width="100%">
                        <AeRatingChart chartData={chartData[suppliers[0].supplierNumber]} score={criteria?.quantitativeData?.find(item => item.supplierNumber === suppliers[0].supplierNumber)?.['points'] || 0}/>
                    </Box>}
                {suppliers.length > 1 &&
                    <Box mt={2} ml={8} mb={2}>
                        {suppliers.map((supplierData) => {
                            const panelId = `panel${supplierData.supplierNumber}`;
                            return (
                                <CardContent
                                    style={{padding: 0, marginTop: 10}}
                                    key={`${supplierData.supplierNumber}${criteria.id}`}>
                                    <div className={classes.root}>
                                        <Accordion
                                            expanded={chartData?.[supplierData.supplierNumber] ? !!expandedPanels[panelId] : expandedPanels[panelId] === `panel${supplierData.supplierNumber}`}
                                            onChange={handleAccordionChange(panelId)}>
                                            <AccordionSummary
                                                className={classes.accordionSummary}
                                                classes={{
                                                    expandIcon: classes.expandIcon,
                                                    content: classes.nestedContent,
                                                    expanded: classes.expanded
                                                }}
                                                expandIcon={chartData?.[supplierData.supplierNumber] ? <ExpandMoreIcon/> :
                                                    <ExpandMoreIcon style={{display: "none"}}/>}
                                                aria-controls={`${panelId}-content`}
                                                id={`${panelId}-header`}
                                            >
                                                <Grid container alignItems="flex-start">
                                                    <Grid item xs={12} md={10}>
                                                        {functionalAreaId !== 2 && suppliers.length > 1 && !criteria.criteria.includes("QPPM") &&
                                                            <Box display="flex"
                                                                 justifyContent="flex-start"
                                                                 alignItems="center">
                                                                <Typography fontWeight="semibold"
                                                                            style={{paddingRight: '2rem'}}>
                                                                    {supplierData.supplierName} - {parseInt(supplierData.supplierNumber)}
                                                                </Typography>
                                                            </Box>
                                                        }
                                                        {functionalAreaId !== 2 && suppliers.length > 1 && criteria.criteria.includes("QPPM") &&
                                                            <>
                                                                {criteria.quantitativeData && criteria.quantitativeData.map((item) => {
                                                                        if (item.supplierNumber === supplierData.supplierNumber) {
                                                                            return (
                                                                                <RatingObjectiveQPPMDetails
                                                                                    title={`${supplierData.supplierName} - ${parseInt(supplierData.supplierNumber)}`}
                                                                                    qbicName={item.qbicName}
                                                                                    quartile={item.quartile}
                                                                                    path={path}
                                                                                    index={item.supplierNumber}
                                                                                    key={item.supplierNumber}/>
                                                                            )
                                                                        }
                                                                        return null;
                                                                    }
                                                                )}
                                                            </>
                                                        }
                                                    </Grid>
                                                    <Grid item xs={12} md={2}>
                                                        {criteria.quantitativeData && criteria.quantitativeData.map((item) => {
                                                                if (item.supplierNumber === supplierData.supplierNumber) {
                                                                    return (
                                                                        <Box display="flex"
                                                                             justifyContent="flex-end" pr={2}
                                                                             key={item.supplierNumber}>
                                                                            <Grid container alignItems="center" spacing={2}>
                                                                                <Grid item xs={12}>
                                                                                    <Box display="flex"
                                                                                         justifyContent="flex-end">
                                                                                        <Typography size="xl"
                                                                                                    fontWeight="semibold">{toCapitalizeSplitStr(item.points)}</Typography>
                                                                                    </Box>
                                                                                </Grid>
                                                                                {item.lastUpdateDate !== "" &&
                                                                                    <Grid item xs={12}>
                                                                                        <Box display="flex"
                                                                                             justifyContent="flex-end">
                                                                                            <Typography color="tertiary"
                                                                                                        size="sm" style={{ marginLeft: '-180px' }}>
                                                                                                {LAST_UPLOADED_DATE}: {item.lastUpdateDate}
                                                                                            </Typography>
                                                                                        </Box>
                                                                                    </Grid>
                                                                                }
                                                                            </Grid>
                                                                        </Box>
                                                                    )
                                                                }
                                                                return null;
                                                            }
                                                        )}
                                                    </Grid>
                                                </Grid>
                                            </AccordionSummary>
                                            {chartData?.[supplierData.supplierNumber] && <AccordionDetails>
                                                <Box width="100%">
                                                    <AeRatingChart chartData={chartData[supplierData.supplierNumber]} score={criteria?.quantitativeData?.find(item => item.supplierNumber === supplierData.supplierNumber)?.['points'] || 0}/>
                                                </Box>
                                            </AccordionDetails>}
                                        </Accordion>
                                    </div>
                                </CardContent>
                            )
                        })}
                    </Box>
                }
            </Grid>
        </Grid>
    </AccordionDetails>
}
